/**
 * The kinds of work a service covers.
 *
 * A service is performed either against a whole site or against a single
 * panel, and both the service catalog and its per-customer prices are
 * filtered by that distinction, so the choices are named once here.
 *
 * Contains:
 * - serviceTypeOptions — the filter choices, translated
 *
 * Returns plain JS — no JSX.
 */

/**
 * Return the service-type filter choices.
 *
 * @param {(key: string, fallback?: string) => string} t - i18next translator.
 * @returns {Array<{label: string, value: string}>} Choices in display order.
 */
export function serviceTypeOptions(t) {
  return [
    { label: t('projectServices.servicePrices.types.site'), value: 'site' },
    { label: t('projectServices.servicePrices.types.panel', 'Panel'), value: 'panel' },
  ];
}
